export default "__VITE_ASSET__CXUP9zwG__"